import { ChangeDetectionStrategy, Component, Inject, Input, OnInit } from '@angular/core';

import { OddsDisplayFormat } from '@frontend/sports/types/models/user-settings';
import { NumpadService } from 'packages/sports/web/app/src/numpad/numpad.service';
import { Observable, combineLatest, distinctUntilChanged, map } from 'rxjs';

import {
    ILinearContainerStakeService,
    LINEAR_CONTAINER_STAKE_SERVICE,
} from '../../../../stake/services/digital/linear/linear-container-stake.interface';

@Component({
    selector: 'bs-linear-container-summary',
    templateUrl: './linear-container-summary.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./linear-container-summary.component.scss'],
    standalone: false,
})
export default class LinearContainerSummaryComponent implements OnInit {
    @Input() oddsDisplayFormat?: OddsDisplayFormat;
    @Input() showOdds: boolean;
    @Input() isDisabled?: boolean;
    @Input() indicateOddsChange = false;

    showSummary$: Observable<boolean>;

    constructor(
        @Inject(LINEAR_CONTAINER_STAKE_SERVICE) private linearContainerStakeService: ILinearContainerStakeService,
        private numpadService: NumpadService,
    ) {}

    ngOnInit(): void {
        const stake$ = this.linearContainerStakeService.getStake$();

        const isNumpadActive$ = this.numpadService.state$.pipe(
            map((state) => state.isOpened),
            distinctUntilChanged(),
        );

        const hasStake$ = stake$.pipe(map((stake) => !!stake && !!stake?.stake));
        const freeBet$ = this.linearContainerStakeService.getFreeBetToken$();

        this.showSummary$ = combineLatest([isNumpadActive$, hasStake$, freeBet$]).pipe(
            map(([isNumpadOpen, hasStake, freeBet]) => !!freeBet || hasStake || isNumpadOpen),
        );
    }
}
